<template>
    <div class="d-flex flex-column" style="min-height: 100vh;">
        <Toasts :firebase-uid="$page.props.auth_uid"/>
        <FlashMessages />

        <div class="mx-5 mt-5 flex-grow-1">
            <div class="d-flex flex-column gap-2">
                <!-- BACK BUTTON -->
                <div class="mb-1">
                    <a :href="$route('integrations.index')" class="btn btn-secondary btn-hover-warning bg-white">
                        <i class="fas fa-arrow-circle-left"/>
                        <span class="px-1">{{ __('general.integrations') }}</span>
                    </a>
                </div>

                <div class="card card-body d-flex flex-column gap-1 text-center p-4 bg-light-warning border border-warning">
                    <h2 class="m-0">{{ integration.name }}</h2>
                    <div class="text-muted">{{ integration.description || 'Keine Beschreibung verfügbar' }}</div>
                    <div>
                        <div class="badge bg-light-warning text-warning">
                            <i class="fas fa-check"/>
                            {{ __('integrations.inactive') }}
                        </div>
                    </div>
                </div>

                <slot />

            </div>
        </div>

        <PageFooter />
    </div>
</template>

<script>
import Toasts from '@components/Toasts.vue';
import StoreHeader from '@components/Store/StoreHeader.vue';
import IntegrationSettingsStores from '@components/Integrations/IntegrationSettingsStores.vue';
import PageFooter from '@layouts/Includes/PageFooter.vue';
import FlashMessages from '@components/FlashMessages.vue';
import IntegrationSettingsOAuth from '@components/Integrations/IntegrationSettingsOAuth.vue';
import IntegrationSettingsHeader from '@components/Integrations/IntegrationSettingsHeader.vue';

export default {
    name: 'IntegrationAuthSettingsLayout',
    components: {
        IntegrationSettingsHeader,
        IntegrationSettingsOAuth,
        FlashMessages,
        PageFooter,
        IntegrationSettingsStores,
        StoreHeader,
        Toasts,
    },

    computed: {
        integration() {
            return this.$page.props.integration
        },
    },
};
</script>
